import React from 'react';
import { CircleXIcon } from 'lucide-react';
import { Section } from './Shared';
import { painPoints } from '../data/pack';
export function PainPoints() {
  return <Section className="max-w-4xl" data-id="element-187" data-mp="2lp56culdt8v9">
      <div className="text-center" data-id="element-188" data-mp="26z7nmu681bdg">
        <h2 className="font-display text-2xl font-bold leading-tight text-brand-ink md:text-4xl" data-id="element-189" data-mp="26xwhwot7ttjp">
          ¿Cuántos pacientes más vas a atender sin el sistema visual que tu
          práctica merece?
        </h2>
        <div className="mx-auto mt-7 max-w-2xl space-y-4 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-190" data-mp="1xzue61i3kmsq">
          <p data-id="element-191" data-mp="21x08jvq3hf6w">
            Sos terapeuta holístico o energético. Invertiste años en tu
            formación. Entendés de chakras, trabajás con energía, sabés que el
            cuerpo es sagrado.
          </p>
          <p data-id="element-192" data-mp="3idl59hadsul1">
            Creés en el poder de la forma y la vibración. En que el universo es
            geométrico. En que una red de cristales bien colocada cambia la vida
            de una persona.
          </p>
          <p className="font-semibold" data-id="element-193" data-mp="1z056eydewiwg">
            Pero hay algo que ningún curso de cristales o energía te dio:
          </p>
          <p className="font-semibold text-brand-teal" data-id="element-194" data-mp="1u0so8qxhk007">
            Un sistema visual clínico, rápido y preciso para usar dentro de la
            sesión.
          </p>
          <p className="font-serif text-xl italic text-brand-violet" data-id="element-195" data-mp="23qvg2nsvf7wy">
            No para estudiar. No para repasar. Para usar mientras el paciente
            está en la camilla.
          </p>
        </div>
      </div>
      <div className="glass-panel mt-10 rounded-3xl border-brand-rose/25 p-6 md:p-9" data-id="element-196" data-mp="1b3rfcv0t9fqz">
        <h3 className="flex items-center gap-2 font-display text-base font-bold text-brand-ink md:text-lg" data-id="element-197" data-mp="1p2r4s4w5dyo7">
          <CircleXIcon className="h-5 w-5 text-brand-rose" data-id="element-198" data-mp="1k2cushazkenj" />
          LO QUE PASA SIN EL ATLAS DE GEOMETRÍA™
        </h3>
        <ul className="mt-6 space-y-4" data-id="element-199" data-mp="30g31lvthph0v">
          {painPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-200" data-mp="2vhjgtyqmuba3">
              <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-rose" aria-hidden="true" data-id="element-201" data-mp="1t7hnm7fqsi2o" />
              {point}
            </li>)}
        </ul>
      </div>
    </Section>;
}